module.exports = __webpack_public_path__ + "images/register/step2-icon.c045bf85.svg";